import { render, staticRenderFns } from "./FloatingDial.vue?vue&type=template&id=0d2a09c6&scoped=true&"
import script from "./FloatingDial.vue?vue&type=script&lang=js&"
export * from "./FloatingDial.vue?vue&type=script&lang=js&"
import style0 from "./FloatingDial.vue?vue&type=style&index=0&id=0d2a09c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a09c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpeedDial } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSpeedDial})
